/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offers_Buy_FailedInputs */

const en_offers_buy_failed = /** @type {(inputs: Offers_Buy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not start the payment. Try again.`)
};

const pl_offers_buy_failed = /** @type {(inputs: Offers_Buy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się rozpocząć płatności. Spróbuj ponownie.`)
};

/**
* | output |
* | --- |
* | "Could not start the payment. Try again." |
*
* @param {Offers_Buy_FailedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const offers_buy_failed = /** @type {((inputs?: Offers_Buy_FailedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offers_Buy_FailedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_offers_buy_failed(inputs)
	return en_offers_buy_failed(inputs)
});